<div class="container">
  <app-header class="header-content"></app-header>
  <main id="main-content" class="content">
    <router-outlet></router-outlet>
  </main>
  <app-footer></app-footer>
</div>
